module.exports = __webpack_public_path__ + "static/img/rule.e6e1002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rule.jpg
// module id = V4GM
// module chunks = 1